const homeFaqs = [
    {
        q: 'Do I need home security?',
        a:
            'Yes, Home security is much more than intrusion protection. We hope that no one ever has to experience this terrifying reality of owning a home. There are even greater threats that we often overlook such as Fire, Carbon Monoxide Poisoning, Flooding and Freezing. Peace-of-mind means not worrying when you are away or home alone. It is knowing that everything is ok, and being reassured, daily. We believe everyone deserves to have this feeling.',
        visible: false
    },
    {
        q: 'What makes True Security different?',
        a:
            'Our main goal is to provide you with the most accurate information with 100% price transparency all inside an enjoyable and informative experience. <br> <br>We are truly committed to helping protect the things that are important to you. We love helping protect people and there their things too! It’s important to us that our customers get a feeling of peace of mind with true security. When you use True Security you are not participating in a sales pitch, you are experiencing the most refined and knowledgeable security tool in existence.',
        visible: false
    },
    {
        q: 'How is this experience better?',
        a:
            'It’s completely done on your own time without any pressure. We are focused on building tools that empower you to make informed decisions. ',
        visible: false
    },
    {
        q: 'Why ADT Monitoring?',
        a:
            'We love ADT because they represent strength and innovation in the security industry. ADT really cares about their customers, we have seen firsthand how much effort and investment they have made improving their customer experience. ADT is also has 6 State-of-the-art redundant monitoring centers. This means you have someone watching your system 24/7.',
        visible: false
    }
]

export default homeFaqs
